import { createAction, props } from '@ngrx/store';

export const initialize = createAction('[Cookie Consent] Initialize', props<{ status?: boolean }>());
export const changed = createAction('[Cookie Consent] Changed', props<{ status: boolean }>());
export const reset = createAction('[Cookie Consent] Reset');
